import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const BuzzerOnGlyph = /*#__PURE__*/createElement("g", {
  id: "buzzer_on"
}, /*#__PURE__*/createElement("path", {
  d: "M48.55 19.67c-.63-.35-1.42-.29-2.09.14L29.47 30.75c-.21.14-.41.31-.59.51H16.96c-1.23 0-2.24 1-2.24 2.24v17.01c0 1.23 1 2.23 2.24 2.23h11.93c.18.2.37.37.59.51l16.98 10.94c.38.24.79.37 1.19.37.31 0 .62-.08.9-.23.64-.35 1.02-1.03 1.02-1.83v-41c0-.8-.38-1.48-1.02-1.83zM17.3 33.84h10.69v16.32H17.3V33.84zm29.27 26.85l-15.44-9.95a.707.707 0 01-.13-.21V33.5c.01-.07.08-.2.11-.23l15.47-9.97v37.39zm5.61-6.9a1.5 1.5 0 01-1.05-2.57c2.5-2.46 3.87-5.75 3.87-9.25 0-3.48-1.35-6.74-3.82-9.2a1.49 1.49 0 010-2.12 1.49 1.49 0 012.12 0c3.03 3.02 4.7 7.04 4.7 11.32 0 4.32-1.69 8.36-4.77 11.39-.29.29-.67.43-1.05.43zm8.46 10.29a1.5 1.5 0 01-1.05-2.57c5.28-5.21 8.19-12.16 8.19-19.57 0-7.35-2.87-14.26-8.07-19.45a1.49 1.49 0 010-2.12 1.49 1.49 0 012.12 0c5.77 5.76 8.95 13.42 8.95 21.58 0 8.22-3.23 15.94-9.09 21.71-.29.28-.67.42-1.05.42z"
}), /*#__PURE__*/createElement("path", {
  d: "M56.26 58.93a1.5 1.5 0 01-1.05-2.57c3.89-3.83 6.03-8.95 6.03-14.41 0-5.41-2.11-10.5-5.94-14.32a1.49 1.49 0 010-2.12 1.49 1.49 0 012.12 0c4.4 4.39 6.82 10.23 6.82 16.45 0 6.27-2.46 12.15-6.93 16.55-.29.28-.67.42-1.05.42z"
}));
const BuzzerOn = createSvg({
  name: 'buzzer_on',
  path: BuzzerOnGlyph
});

export default BuzzerOn;
export { BuzzerOnGlyph };
